import PropTypes from 'prop-types'
import { text } from 'chaoskit/src/assets/styles/utility'
import { forwardRef } from 'react'
import { useTheme } from '@emotion/react'

import TextLink from './TextLink'

const ResourceCard = forwardRef(
  ({ data, title, bottomContent, ...rest }, ref) => {
    const theme = useTheme()

    const borderSize = 8

    return (
      <TextLink
        data-resource-link
        ref={ref}
        href={`${data.slug}${data.contentId ? `#${data.contentId}` : ''}`}
        css={{
          background: theme.color.light.base,
          display: 'flex',
          flexDirection: 'column',
          border: theme.border.base,
          paddingTop: theme.space.base,
          paddingRight: theme.space.base,
          paddingBottom: theme.space.base + borderSize,
          paddingLeft: theme.space.base,
          borderTopLeftRadius: theme.borderRadius.base,
          borderTopRightRadius: theme.borderRadius.base,
          boxShadow: theme.boxShadow.base,
          position: 'relative',
          transition: `transform ${theme.timing.base} ${theme.transition.bounce}`,
          backfaceVisibility: 'hidden',

          [theme.mq.medium]: {
            paddingTop: theme.space.medium,
            paddingRight: theme.space.medium,
            paddingBottom: theme.space.medium + borderSize,
            paddingLeft: theme.space.medium,
          },

          '&:hover': {
            transform: 'scale(1.025)',
          },

          '&::after': {
            content: "''",
            height: borderSize,
            background: theme.color.dark.base,
            left: 0,
            width: '100%',
            bottom: 0,
            position: 'absolute',
          },
        }}
        {...rest}
      >
        <div css={{ flex: 1 }}>
          {data.articleLabel && (
            <div
              data-resource-article-label
              css={[
                text.heading(theme),
                {
                  fontWeight: theme.fontWeight.base,
                  letterSpacing: theme.letterSpacing.small,
                  fontSize: theme.fontSize.xsmall,
                  color: theme.fontColor.muted,
                  textTransform: 'uppercase',
                  marginBottom: theme.space.small,
                },
              ]}
            >
              {data.articleLabel}
            </div>
          )}
          <h3
            css={{
              marginTop: 0,
              fontSize: theme.fontSize.large,
            }}
            data-resource-title
          >
            {title}
          </h3>
        </div>
        {bottomContent}
      </TextLink>
    )
  }
)

ResourceCard.propTypes = {
  bottomContent: PropTypes.any,
  data: PropTypes.shape({
    articleLabel: PropTypes.string,
    contentId: PropTypes.string,
    slug: PropTypes.string.isRequired,
  }),
  // This is pulled away from the `data` shape since we need to wrap it with the Algolia search provider funcs in `algolia-resources`
  title: PropTypes.any.isRequired,
}

export default ResourceCard
